export default "__VITE_ASSET__d14efc63__"